import { ImagesSliderComponent } from './ImagesSlider';
export default ImagesSliderComponent;
